import { store } from '../../store'

export const sendQuestionnairePush = async ( id: number ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/questionnaires/${ id }/push`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'SEND_QUESTIONNAIRE_PUSH_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'SEND_QUESTIONNAIRE_PUSH_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'SEND_QUESTIONNAIRE_PUSH_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'SEND_QUESTIONNAIRE_PUSH_OK' } )

}
